// The five buckets a lead lands in, named and coloured the same on the global
// CRM and on every campaign's CRM tab. Mirrors OUTREACH_CRM_CATEGORY_* in
// backend/apps/autoleads/constants.py.
import {
  BadgeCheck,
  CircleDashed,
  CircleX,
  Flame,
  type LucideIcon,
  UserRoundX,
} from "lucide-react"

import type { LeadCategory } from "@/nango/types/apps.autoleads/autoleads/AutoLeads"

export const LEAD_CATEGORY_T = {
  categoryAll: { FR: "Toutes", EN: "All" },
  categoryProspect: { FR: "Prospect", EN: "Prospect" },
  categoryHot: { FR: "Chaud", EN: "Hot" },
  categoryClient: { FR: "Client", EN: "Client" },
  categoryChurned: { FR: "Client perdu", EN: "Churned client" },
  categoryLost: { FR: "Perdu", EN: "Lost" },
}

type CategoryLabelKey = keyof typeof LEAD_CATEGORY_T

// Display order: the pipeline read left to right, the dead ends last.
export const LEAD_CATEGORIES: readonly LeadCategory[] = [
  "prospect",
  "hot",
  "client",
  "churned",
  "lost",
]

// Where nothing is in play any more: listed last, worth nothing.
export const CLOSED_LEAD_CATEGORIES: readonly LeadCategory[] = [
  "churned",
  "lost",
]

export const LEAD_CATEGORY_META: Record<
  LeadCategory,
  {
    Icon: LucideIcon
    // Optical compensation: the flame fills less of its box than the round
    // glyphs, so at the same size it reads smaller next to them.
    iconClassName: string
    labelKey: CategoryLabelKey
    variant: "outline" | "destructive-soft" | "success-soft"
    tone: "default" | "muted"
  }
> = {
  prospect: {
    Icon: CircleDashed,
    iconClassName: "",
    labelKey: "categoryProspect",
    variant: "outline",
    tone: "default",
  },
  hot: {
    Icon: Flame,
    iconClassName: "scale-110",
    labelKey: "categoryHot",
    variant: "destructive-soft",
    tone: "default",
  },
  client: {
    Icon: BadgeCheck,
    iconClassName: "",
    labelKey: "categoryClient",
    variant: "success-soft",
    tone: "default",
  },
  churned: {
    Icon: UserRoundX,
    iconClassName: "",
    labelKey: "categoryChurned",
    variant: "outline",
    tone: "default",
  },
  lost: {
    Icon: CircleX,
    iconClassName: "",
    labelKey: "categoryLost",
    variant: "outline",
    tone: "muted",
  },
}
